// Tüm içeriği güncellenmiş Optik V2 CRM LandingPage bileşeni
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence, Variants } from 'framer-motion';
import slide1 from './assets/hero1.jpg';
import slide2 from './assets/hero2.jpg';
import slide3 from './assets/hero3.jpg';
import slide4 from './assets/hero4.jpg';
import motivationImg from './assets/motivation.jpg';

export interface ILandingPage {}

const navItems = [
    { id: 'hero', label: 'Anasayfa' },
    { id: 'features', label: 'Özellikler' },
    { id: 'partners', label: 'İş Ortaklarımız' },
    { id: 'pricing', label: 'Fiyatlandırma' },
    { id: 'contact', label: 'İletişim' },
];

const heroSlides = [
    {
        title: 'Müşteri Takibi Artık Çok Kolay',
        desc: 'Her müşterinizin geçmiş işlemlerine, randevularına ve reçetelerine tek yerden ulaşın.',
        bg: `url(${slide1}) center/cover no-repeat`
    },
    {
        title: 'Stoklarınızı Anlık Yönetin',
        desc: 'Gözlük, lens ve aksesuar stoklarınızı şube bazlı takip edin, kritik stok seviyelerini anında görün.',
        bg: `url(${slide2}) center/cover no-repeat`
    },
    {
        title: 'Satış Performansını Artırın',
        desc: 'Şube ve personel bazlı satış raporlarıyla verimliliği ölçün, hedefler belirleyin.',
        bg: `url(${slide3}) center/cover no-repeat`
    },
    {
        title: 'Görsel Satış Panelleri',
        desc: 'Günlük satış, ciro, hedef gerçekleşme oranlarını grafiklerle takip edin.',
        bg: `url(${slide4}) center/cover no-repeat`
    },
];

const features = [
    { icon: '🧾', title: 'Müşteri ve Reçete Yönetimi', desc: 'Tüm müşteri bilgilerini, reçeteleri ve geçmiş satışları eksiksiz şekilde saklayın.' },
    { icon: '🕶️', title: 'Ürün ve Marka Takibi', desc: 'Marka, model ve kategori bazlı ürün yönetimi yapın; stok hareketlerini analiz edin.' },
    { icon: '📈', title: 'Satış ve Ciro Analizi', desc: 'Şubelerinizin satış performanslarını gün gün karşılaştırın.' },
    { icon: '🏬', title: 'Çoklu Şube Desteği', desc: 'Birden fazla şubenizi tek merkezden yönetin, karşılaştırmalı raporlar alın.' },
    { icon: '👨‍⚕️', title: 'Personel Bazlı Raporlama', desc: 'Satış personelinizin performansını ölçün ve hedeflerle kıyaslayın.' },
    { icon: '💬', title: 'Hatırlatma ve Uyarı Sistemi', desc: 'Periyodik kontrol tarihleri, stok uyarıları ve müşteri doğum günleri için otomatik bildirimler alın.' },
];

const partners = [
    { name: 'OptikPlus', logo: 'https://logo.clearbit.com/optikplus.com', url: 'https://www.optikplus.com' },
    { name: 'LensaMed', logo: 'https://logo.clearbit.com/lensamed.com.tr', url: 'https://www.lensamed.com.tr' },
    { name: 'Vizyon Optik', logo: 'https://logo.clearbit.com/vizyonoptik.com', url: 'https://www.vizyonoptik.com' },
];

const pricing = [
    {
        tier: 'Başlangıç',
        price: '₺0',
        description: 'Yeni başlayan optikçiler için ideal',
        features: ['1 şube', 'Sınırlı müşteri kaydı', 'Temel satış raporları']
    },
    {
        tier: 'Profesyonel',
        price: '₺499',
        description: 'Aktif satış yapan işletmeler için',
        features: ['5 kullanıcı', 'Stok ve satış yönetimi', 'Şube bazlı raporlama']
    },
    {
        tier: 'Kurumsal',
        price: '₺999',
        description: 'Çok şubeli yapılar için',
        features: ['Sınırsız kullanıcı', 'Çoklu şube desteği', 'Personel performans raporları']
    },
    {
        tier: 'Özel',
        price: 'Teklif Alın',
        description: 'Özel entegrasyon ve ihtiyaçlara uygun çözüm',
        features: ['On-premise kurulum', 'API erişimi', 'Kişiselleştirilmiş destek']
    },
];

const footerLinks = {
    urunler: ['Müşteri Yönetimi', 'Satış Raporlama', 'Stok Takibi'],
    kaynaklar: ['Kullanım Kılavuzu', 'SSS', 'Veri Güvenliği'],
    sirket: ['Hakkımızda', 'Referanslar', 'İletişim'],
    destek: ['Canlı Destek', 'Destek Talebi', 'Kullanıcı Topluluğu']
};

export { heroSlides, features, partners, pricing, navItems, footerLinks };
export default ILandingPage;
